import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import ComingSoon from "@/components/ComingSoon";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import Leads from "@/pages/Leads";
import Students from "@/pages/Students";
import StudentProfile from "@/pages/StudentProfile";
import Payments from "@/pages/Payments";
import Courses from "@/pages/Courses";
import Batches from "@/pages/Batches";
import Trainers from "@/pages/Trainers";
import Enrollments from "@/pages/Enrollments";
import Placement from "@/pages/Placement";
import Reports from "@/pages/Reports";
import Sales from "@/pages/Sales";
import Notifications from "@/pages/Notifications";
import Settings from "@/pages/Settings";

const page = (Component) => (
  <ProtectedRoute>
    <Layout>
      <Component />
    </Layout>
  </ProtectedRoute>
);

const soon = (title, subtitle) => page(() => <ComingSoon title={title} subtitle={subtitle} />);

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />

            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/dashboard" element={page(Dashboard)} />
            <Route path="/leads" element={page(Leads)} />
            <Route path="/students" element={page(Students)} />
            <Route path="/students/:id" element={page(StudentProfile)} />
            <Route path="/enrollments" element={page(Enrollments)} />
            <Route path="/sales" element={page(Sales)} />
            <Route path="/payments" element={page(Payments)} />
            <Route path="/courses" element={page(Courses)} />
            <Route path="/batches" element={page(Batches)} />
            <Route path="/trainers" element={page(Trainers)} />
            <Route path="/placement" element={page(Placement)} />
            <Route path="/reports" element={page(Reports)} />
            <Route path="/notifications" element={page(Notifications)} />
            <Route path="/settings" element={page(Settings)} />

            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
